import _forOwn from 'lodash/forOwn'
import DOMPurify from 'dompurify'
import PhoneLib from 'google-libphonenumber'

const ADDRESS = {
    format(d, v) {
        let r = []
        if (v && v instanceof Object) {
            if (this._has(d, 'address1') && this._val(v, 'address1')) {
                r.push(v['address1'])
            }
            if (this._has(d, 'address2') && this._val(v, 'address2')) {
                r.push(v['address2'])
            }
            if (this._has(d, 'city') && this._val(v, 'city')) {
                r.push(v['city'])
            }
            if (this._has(d, 'state') && this._val(v, 'state')) {
                r.push(v['state'])
            }
            if (this._has(d, 'zip') && this._val(v, 'zip')) {
                r.push(v['zip'])
            }
            if (this._has(d, 'country') && this._val(v, 'country')) {
                r.push(v['country'])
            }
        }
        return DOMPurify.sanitize(r.join(', '))
    },
    compare(a, op, b) {
        if (b === '*') {
            return (op == '!=' && !a) || (op != '!=' && a && this.validate(null, a))
        }
        return (op == '!=') ? this.format(null, a) != b : this.format(null, a) == b
    },
    validate(d, v) {
        return (!this._has(d, 'address1') || this._val(v, 'address1'))
            && (!this._has(d, 'city') || this._val(v, 'city'))
            && (!this._has(d, 'zip') || this._val(v, 'zip'))
            && (!this._has(d, 'state') || this._val(v, 'state'))
            && (!this._has(d, 'country') || this._val(v, 'country'))
    },
    _has(o, k) {
        if (o == null) {
            return true
        }
        return o.options && o.options.hasOwnProperty(k) && o.options[k] == true
    },
    _val(v, k) {
        return v && v.hasOwnProperty(k) && v[k] && v[k].length > 0
    }
}
const CALCULATED = {
    format(d, v, defaults) {
        let type = d.options.type
        let numeric = type == 'TEXT' || type == 'BOOLEAN' ? false : true
        if(!numeric || !v) {
            return v
        }

        let p = d.options && d.options.hasOwnProperty('precision') ? d.options['precision'] : 2
        let f = Intl.NumberFormat([defaults.l, defaults.l.split("-")[0], defaults.l.split("-")[1]], { minimumFractionDigits: p, maximumFractionDigits: p })
        if(!f) {
            return ''
        }

        let c = d.options && d.options.hasOwnProperty('currency') && d.options['currency'] ? d.options['currency'] : defaults.c
        if(c) {
            return c + ' ' + f.format(v)
        }

        return f.format(v)
    },
    compare(a, op, b) {
        try {
            if (b === '*') {
                return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
            }
            if (op == '==') return a == b
            if (op == '!=') return a != b
            if (op == '>=') return parseFloat(a) >= parseFloat(b)
            if (op == '<=') return parseFloat(a) <= parseFloat(b)
            if (op == 'between') return parseFloat(a) >= parseFloat(b.split(',')[0]) && parseFloat(a) <= parseFloat(b.split(',')[1])
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return v && v.length > 0
    }
}
const CURRENCY = {
    format(d, v, defaults) {
        let p = d.options && d.options.hasOwnProperty('precision') ? d.options['precision'] : 2
        let f = Intl.NumberFormat([defaults.l, defaults.l.split("-")[0], defaults.l.split("-")[1]], { minimumFractionDigits: p, maximumFractionDigits: p })
        let c = d.options && d.options.hasOwnProperty('currency') && d.options['currency'] ? d.options['currency'] : defaults.c

        return v && f ? c + ' ' + f.format(v) : ''
    },
    compare(a, op, b) {
        try {
            if (b === '*') {
                return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
            }
            if (op == '==') return parseFloat(a) == parseFloat(b)
            if (op == '!=') return parseFloat(a) != parseFloat(b)
            if (op == '>=') return parseFloat(a) >= parseFloat(b)
            if (op == '<=') return parseFloat(a) <= parseFloat(b)
            if (op == 'between') return parseFloat(a) >= parseFloat(b.split(',')[0]) && parseFloat(a) <= parseFloat(b.split(',')[1])
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return !isNaN(parseFloat(v))
    }
}
const DATE = {
    format(d, v, defaults) {
        let f = new Intl.DateTimeFormat([defaults.l, defaults.l.split("-")[0], defaults.l.split("-")[1]])
        return v && f ? f.format(new Date(v)) : ''
    },
    compare(a, op, b) {
        try {
            if (b === '*') {
                return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
            }
            if (op == '==') return new Date(a) == new Date(b)
            if (op == '!=') return new Date(a) != new Date(b)
            if (op == '>=') return new Date(a) >= new Date(b)
            if (op == '<=') return new Date(a) <= new Date(b)
            if (op == 'between') return new Date(a) >= new Date(b.split(',')[0]) && new Date(a) <= new Date(b.split(',')[1])
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return v && v.length > 0
    }
}
const DROPDOWN = {
    format(d, v, defaults) {
        let result = v.split('|').length == 2 ? '' : v
        try {
            d.options.structure.groups.forEach(g => {
                if (g.scope == 'static' && g.items.find(i => i.value == v)) {
                    result = g.items.find(i => i.value == v).label
                }
                if (g.scope != 'static' && g.scope.split('|')[1] == v.split('|')[0] && d.values.find(i => i.value == v)) {
                    result = d.values.find(i => i.value == v).label
                }
            })
        } catch (error) {
            return DOMPurify.sanitize(result)
        }
        return DOMPurify.sanitize(result)
    },
    compare(a, op, b) {
        try {
            if (b === '*') {
                return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
            }
            if (op == '==') return a == b
            if (op == '!=') return a != b
            if (op == '>=') return parseFloat(a) >= parseFloat(b)
            if (op == '<=') return parseFloat(a) <= parseFloat(b)
            if (op == 'between') return parseFloat(a) >= parseFloat(b.split(',')[0]) && parseFloat(a) <= parseFloat(b.split(',')[1])
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return v && v.length > 0
    }
}
const DOCUMENT = {
    format(d, v, defaults) {
        return v && v instanceof Array && v.length > 0 ? v.length + ' uploaded document(s)' : 'none'
    },
    compare(a, op, b) {
        let v = a && a instanceof Array ? a.length : 0
        try {
            if (b === '*') {
                return (op == '!=' && !v) || (op != '!=' && v)
            }
            if (op == '==') return parseFloat(v) == parseFloat(b)
            if (op == '!=') return parseFloat(v) != parseFloat(b)
            if (op == '>=') return parseFloat(v) >= parseFloat(b)
            if (op == '<=') return parseFloat(v) <= parseFloat(b)
            if (op == 'between') return parseFloat(v) >= parseFloat(b.split(',')[0]) && parseFloat(v) <= parseFloat(b.split(',')[1])
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return v && v.length > 0
    }
}
const EMAIL = {
    format(d, v, defaults) {
        return v ? DOMPurify.sanitize(v.toString()) : ''
    },
    compare(a, op, b) {
        if (b === '*') {
            return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
        }
        return (op == '!=') ? a != b : a == b
    },
    validate(d, v) {
        return v && v.length > 0
    }
}
const ENCRYPTED = {
    format(d, v, defaults) {
        return v && v.hasOwnProperty('formatted') ? v.formatted.toString() : (v ? v.toString() : '')
    },
    compare(a, op, b) {
        if (b === '*') {
            return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
        }
        let aval = (a && a.formatted) ? a.formatted : a
        let bval = (b && b.formatted) ? b.formatted : b

        return (op == '!=') ? aval != bval : aval == bval
    },
    validate(d, v) {
        return v && v.length > 0
    }
}
const IMAGE = {
    format(d, v, defaults) {
        if (v && v instanceof Array) {
            return v.length > 0 ? v.length + ' uploaded image(s)' : 'none'
        }

        if (v && v instanceof String) {
            return '1 uploaded image(s)'
        }

        return 'none'
    },
    compare(a, op, b) {
        let v = a && a.length > 0 ? 1 : 0
        try {
            if (b === '*') {
                return (op == '!=' && !v) || (op != '!=' && v)
            }
            if (op == '==') return parseFloat(v) == parseFloat(b)
            if (op == '!=') return parseFloat(v) != parseFloat(b)
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return v && v.length > 0
    }
}
const NUMERIC = {
    format(d, v, defaults) {
        let p = d.options && d.options.hasOwnProperty('precision') ? d.options['precision'] : 0
        let f = Intl.NumberFormat([defaults.l, defaults.l.split("-")[0], defaults.l.split("-")[1]], { minimumFractionDigits: p, maximumFractionDigits: p })
        return v && f ? f.format(v) : ''
    },
    compare(a, op, b) {
        try {
            if (b === '*') {
                return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
            }
            if (op == '==') return parseFloat(a) == parseFloat(b)
            if (op == '!=') return parseFloat(a) != parseFloat(b)
            if (op == '>=') return parseFloat(a) >= parseFloat(b)
            if (op == '<=') return parseFloat(a) <= parseFloat(b)
            if (op == 'between') return parseFloat(a) >= parseFloat(b.split(',')[0]) && parseFloat(a) <= parseFloat(b.split(',')[1])
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return !isNaN(parseFloat(v))
    }
}
const OPTION = {
    format(d, v, defaults) {
        try {
            let result = []
            d.options.structure.groups.forEach(g => {
                if (g.scope == 'static') {
                    v.forEach(value => {
                        if (g.items.find(i => i.value == value)) {
                            result.push(g.items.find(i => i.value == value).label)
                        }
                    })
                }
                if (g.scope != 'static') {
                    v.forEach(value => {
                        if (g.scope.split('|')[1] == value.split('|')[0] && d.values.find(i => i.value == value)) {
                            result.push(d.values.find(i => i.value == value).label)
                        }
                    })
                }
            })
            return DOMPurify.sanitize(result.join(", "))
        } catch (error) {
            return v && typeof v == 'array' ? DOMPurify.sanitize(v.join(", ")) : ''
        }
    },
    compare(a, op, b) {
        try {
            if (b === '*') {
                return (op == '!=' && a.length == 0) || a.length > 0
            }
            for (let i = 0; i < a.length; i++) {
                if (op == '==' && a[i] == b) { return true }
                if (op == '>=' && parseFloat(a[i]) >= parseFloat(b)) { return true }
                if (op == '<=' && parseFloat(a[i]) <= parseFloat(b)) { return true }
                if (op == '!=' && a[i] != b) { return true }
                if (op == 'between' && parseFloat(a[i]) >= parseFloat(b.split(',')[0]) && parseFloat(a[i]) <= parseFloat(b.split(',')[1])) { return true }
            }
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return v && v.length > 0 && v.filter(i => { return i && i.length > 0 }).length > 0
    }
}
const PERCENTAGE = {
    format(d, v, defaults) {
        let p = d.options && d.options.hasOwnProperty('precision') ? d.options['precision'] : 0
        let f = Intl.NumberFormat([defaults.l, defaults.l.split("-")[0], defaults.l.split("-")[1]], { minimumFractionDigits: p })
        return v && f ? f.format(v) + '%' : ''
    },
    compare(a, op, b) {
        try {
            if (b === '*') {
                return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
            }
            if (op == '==') return parseFloat(a) == parseFloat(b)
            if (op == '!=') return parseFloat(a) != parseFloat(b)
            if (op == '>=') return parseFloat(a) >= parseFloat(b)
            if (op == '<=') return parseFloat(a) <= parseFloat(b)
            if (op == 'between') return parseFloat(a) >= parseFloat(b.split(',')[0]) && parseFloat(a) <= parseFloat(b.split(',')[1])
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return !isNaN(parseFloat(v))
    }
}
const PHONE = {
    format(d, v, defaults) {
        if (!v || !v.code || !v.number) { return '' }
        try {
            let lib = PhoneLib.PhoneNumberUtil.getInstance()
            return lib.format(lib.parse(v.code + v.number + (v.hasOwnProperty('ext') && v.ext ? 'x' + v.ext : '')), 1)
        } catch (error) {
            return DOMPurify.sanitize(v.code + " " + v.number + (v.hasOwnProperty('ext') && v.ext ? 'x' + v.ext : ''))
        }
    },
    compare(a, op, b) {
        if (b === '*') {
            return (op == '!=' && !a) || (op != '!=' && a && this.validate(null, a))
        }
        return (op == '!=') ? this.format(null, a) != b : this.format(null, a) == b
    },
    validate(d, v) {
        return v && v.code && v.number && v.code.length > 0 && v.number.length > 0
    }
}
const TEXT = {
    format(d, v, defaults) {
        if(!v) {
            return ''
        }

        v = DOMPurify.sanitize(v.toString())
        if(!d.options) {
            return v
        }

        let lastCharsPreview = d.options.hasOwnProperty('last_chars_preview') ? d.options['last_chars_preview'] : null;
        lastCharsPreview = (lastCharsPreview != null && Number.isInteger(lastCharsPreview) && lastCharsPreview >= 0) ? lastCharsPreview : 0;
        const length = v.length;

        if (d.options.hasOwnProperty('hide_input') && !!d.options['hide_input']) {
            if (lastCharsPreview >= length || lastCharsPreview === 0) {
                return '*'.repeat(length);
            }

            const maskedLength = Math.max(length - lastCharsPreview, 0);
            const visiblePart = v.slice(-Math.min(lastCharsPreview, length));

            return '*'.repeat(maskedLength) + visiblePart;
        }

        return v;
    },
    compare(a, op, b) {
        if (b === '*') {
            return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
        }
        return (op == '!=') ? a != b : a == b
    },
    validate(d, v) {
        return v && v.length > 0
    }
}
const TEXTAREA = {
    format(d, v, defaults) {
        return v ? DOMPurify.sanitize(v.toString()) : ''
    },
    compare(a, op, b) {
        if (b === '*') {
            return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
        }
        return (op == '!=') ? a != b : a == b
    },
    validate(d, v) {
        return v && v.length > 0
    }
}
const YEAR = {
    format(d, v, defaults) {
        return v ? DOMPurify.sanitize(v.toString()) : ''
    },
    compare(a, op, b) {
        try {
            if (b === '*') {
                return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
            }
            if (op == '==') return parseInt(a) == parseInt(b)
            if (op == '!=') return parseInt(a) != parseInt(b)
            if (op == '>=') return parseInt(a) >= parseInt(b)
            if (op == '<=') return parseInt(a) <= parseInt(b)
            if (op == 'between') return parseInt(a) >= parseInt(b.split(',')[0]) && parseInt(a) <= parseInt(b.split(',')[1])
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return v && v.length > 0
    }
}

const ELEMENTSIGNATURE = {
    validate(d, v) {
        return v && v == true
    }
}

const ELEMENTSUM = {
    format(d, v, defaults) {
        return v
    },
    compare(a, op, b) {
        try {
            if (b === '*') {
                return (op == '!=' && !a) || (op != '!=' && a && a.length > 0)
            }
            if (op == '==') return parseFloat(a) == parseFloat(b)
            if (op == '!=') return parseFloat(a) != parseFloat(b)
            if (op == '>=') return parseFloat(a) >= parseFloat(b)
            if (op == '<=') return parseFloat(a) <= parseFloat(b)
            if (op == 'between') return parseFloat(a) >= parseFloat(b.split(',')[0]) && parseFloat(a) <= parseFloat(b.split(',')[1])
        } catch (error) {
            return false
        }
        return false
    },
    validate(d, v) {
        return !isNaN(parseFloat(v))
    }
}

export default {
    ADDRESS,
    CALCULATED,
    CURRENCY,
    DATE,
    DOCUMENT,
    DROPDOWN,
    EMAIL,
    ENCRYPTED,
    IMAGE,
    NUMERIC,
    OPTION,
    PERCENTAGE,
    PHONE,
    TEXT,
    TEXTAREA,
    YEAR,
    ELEMENTSIGNATURE,
    ELEMENTSUM
}
